import { gsap, TimelineMax } from "gsap/all";
import { useEffect, useState, useRef } from 'react';
import ScrollMagic from "scrollmagic";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import Particles from "react-tsparticles";
import { loadConfettiShape } from "tsparticles-shape-confetti";
import {confettiConfig} from "../confettiConfig";
import { cleanup } from "@testing-library/react";
console.log(confettiConfig);
ScrollMagicPluginGsap(ScrollMagic, TimelineMax, TimelineMax);

function House() {

   const [fire, setFire] = useState(false);
   const confettiElem = useRef(null);

   useEffect(() => {
      let tl = new TimelineMax({onUpdate:updatePercentage});
      const controller = new ScrollMagic.Controller();
      tl.set("#house", {transformOrigin: "50% 50%"});
      tl.set("#door", {transformStyle: 'preserve-3d', scaleX: 1})
      tl.set("#handle", {transformOrigin: "100% 0"}) 
      tl.set("#housecontent", {opacity:0, repeat: 0});
 
      tl.to("#handle", 1000, { rotate: -45 });
      tl.to("#door", 1000, { scaleX:-1 });
      tl.to("#handle", 1000, { rotate: 0 });
      tl.to("#house", 2000, { scale: 10, opacity: 0 });
      //tl.to("#house", 2000, { scale: 10, opacity: 0 }).call(triggerConfetti);
     // tl.to("#door", 1, { scale: 2, opacity: 0, repeat: 0});
      tl.to("#housecontent", 1000,{opacity:1, repeat: 0}, 2);


      const scene = new ScrollMagic.Scene({
        triggerElement: "#housecontainer",
        duration: "150%",
        triggerHook: "onLeave",
        reverse: true
      })
      .setPin("#housecontainer")
      .setTween(tl)
      .addTo(controller);

      function updatePercentage() {
         tl.progress();
      }
       scene.on('progress', (e) => {
          console.log(e);
          if (e.progress > 0.7 && e.scrollDirection == "FORWARD") {
            triggerConfetti();
          };
      })
      
      return () => {
         scene.destroy();
      }
   
   }, []);


   let tsp;
   const loadConfetti = (tsparticles) => {
      loadConfettiShape(tsparticles);
    
      tsp = tsparticles;
    };
    const triggerConfetti = () => {
      // setFire(true);
      // setTimeout(() => {setFire(false)}, 3000)


      tsp.domItem(0).play();

      tsp.domItem(0).getEmitter(2).paused = false;
      tsp.domItem(0).getEmitter(1).paused = false;
      tsp.domItem(0).getEmitter(0).paused = false;

      setTimeout(() => {
         tsp.domItem(0).getEmitter(2).paused = true;
         tsp.domItem(0).getEmitter(1).paused = true;
         tsp.domItem(0).getEmitter(0).paused = true;
      }, 1500)
    } 
 
    

    const loaded = (container) => {
      tsp.setOnClickHandler((e, particles) => {
        console.log(particles.length);
      });
    };

   return (
      <>
      <div>
         <div id="housecontainer">
            <Particles ref={confettiElem} id="tsparticles" init={loadConfetti} options={confettiConfig}/>
            <div id="house" class="house-mob">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505.56 648.72">
               <g id="Layer_2" data-name="Layer 2">
                  <g id="SHOWROOM">
                     <ellipse class="cls-1" cx="258.28" cy="630.29" rx="198.62" ry="18.43" />
                  </g>
                  <g id="DOOR">
                     <g class="cls-2">
                     <path
                        d="M149.16,254.52H121.43v-19H64.3v19H9.67v1.66h26.9v18.94H64.3v17.27H36.57V313H64.3v17.27H37.4v1.66H92V350H93.7V331.93h27.73V313h54.62v-1.67H149.16V294.06h27.73V273.45H149.16Zm-1.67,18.93H93.7V256.18h53.79Zm-27.73-19H66V237.18h53.79Zm-81.52,19V256.18H92v17.27H38.24ZM66,275.12h53.79v17.27H66ZM38.24,311.33V294.06H92v17.27H38.24Zm81.52,18.94H66V313h53.79Zm27.73-18.94H93.7V294.06h53.79Zm27.73-36.21v17.27H121.43V275.12h53.79Z"
                     />
                     <path
                        d="M456.6,385V366.07H428.87v-19H371.74v20.6h27.73V385H371.74v20.61H484.33V385Zm-83.19-36.27H427.2V366H373.41Zm27.73,19h53.79V385H401.14ZM427.2,404H373.41V386.68H427.2Zm55.46,0H428.87V386.68h53.79Z"
                     />
                     <rect x="454.93" y="403.95" width="1.67" height="17.03" />
                     <rect
                        x="434.88"
                        y="339.38"
                        width="1.67"
                        height="17.03"
                        transform="translate(783.62 -87.81) rotate(90)"
                     />
                     <rect
                        x="399.47"
                        y="331.7"
                        width="1.67"
                        height="17.03"
                        transform="translate(800.61 680.44) rotate(180)"
                     />
                     </g>
                     <rect class="cls-3" x="116.98" y="91.08" width="265.69" height="539.21" />
                     <rect
                     x="132.83"
                     y="107.33"
                     width="234"
                     height="507.62"
                     fill="#f0f0f0"
                     stroke-width="2"
                     stroke="#002e6e"
                     />
                     
                     <rect class="cls-7" x="132.83" y="614.94" width="234" height="15.34" />

                     <rect class="cls-13" x="1" y="1" width="503.56" height="20.14" />
                     <rect class="cls-14" x="11.81" y="41.29" width="481.93" height="20.14" />
                     <rect class="cls-14" x="49.51" y="61.43" width="23.22" height="51.6" />
                     <rect class="cls-14" x="432.82" y="61.43" width="23.22" height="51.6" />
                     <polygon
                     class="cls-15"
                     points="504.56 21.14 1 21.14 11.81 41.29 493.74 41.29 504.56 21.14"
                     />
                     <rect class="cls-16" x="11.81" y="62.38" width="481.93" height="16.85" />

                     <g id="door">
                     <rect class="cls-4" x="132.83" y="107.33" width="234" height="507.62" />
                     <polygon
                        class="cls-5"
                        points="229.54 151.49 240.13 140.56 240.13 195.55 170.98 195.55 181.57 184.86 229.54 184.86 229.54 151.49"
                     />
                     <polygon
                        class="cls-5"
                        points="229.54 229.85 240.13 218.92 240.13 392.51 170.98 392.51 181.57 380.97 229.54 380.97 229.54 229.85"
                     />
                     <polygon
                        class="cls-5"
                        points="324.92 229.85 335.51 218.92 335.51 392.51 266.36 392.51 276.95 380.97 324.92 380.97 324.92 229.85"
                     />
                     <polygon
                        class="cls-5"
                        points="324.73 447.99 335.32 436.75 335.32 581.12 266.17 581.12 276.76 569.58 324.73 569.58 324.73 447.99"
                     />
                     <polygon
                        class="cls-5"
                        points="229.54 447.99 240.13 436.75 240.13 581.12 170.98 581.12 181.57 569.58 229.54 569.58 229.54 447.99"
                     />
                     <polygon
                        class="cls-6"
                        points="181.57 569.88 170.98 581.12 170.98 436.75 240.13 436.75 229.54 448.3 181.57 448.3 181.57 569.88"
                     />
                     <polygon
                        class="cls-6"
                        points="276.76 569.88 266.17 581.12 266.17 436.75 335.32 436.75 324.73 448.3 276.76 448.3 276.76 569.88"
                     />
                     <polygon
                        class="cls-6"
                        points="276.95 381.58 266.36 392.51 266.36 218.92 335.51 218.92 324.92 230.47 276.95 230.47 276.95 381.58"
                     />
                     <polygon
                        class="cls-6"
                        points="181.57 381.58 170.98 392.51 170.98 218.92 240.13 218.92 229.54 230.47 181.57 230.47 181.57 381.58"
                     />
                     <polygon
                        class="cls-5"
                        points="324.92 151.49 335.51 140.56 335.51 195.55 266.36 195.55 276.95 184.86 324.92 184.86 324.92 151.49"
                     />
                     <polygon
                        class="cls-6"
                        points="276.95 184.62 266.36 195.55 266.36 140.56 335.51 140.56 324.92 151.25 276.95 151.25 276.95 184.62"
                     />
                     <polygon
                        class="cls-6"
                        points="181.57 184.62 170.98 195.55 170.98 140.56 240.13 140.56 229.54 151.25 181.57 151.25 181.57 184.62"
                     />
                     <rect
                        class="cls-8"
                        x="181.57"
                        y="229.85"
                        width="47.97"
                        height="151.11"
                     />
                     <rect
                        class="cls-9"
                        x="170.98"
                        y="218.92"
                        width="69.15"
                        height="173.59"
                     />
                     <rect
                        class="cls-9"
                        x="170.98"
                        y="436.75"
                        width="69.15"
                        height="144.37"
                     />
                     <rect class="cls-9" x="170.98" y="140.56" width="69.15" height="55" />
                     <rect
                        class="cls-7"
                        x="212.26"
                        y="403.43"
                        width="81.04"
                        height="21.02"
                     />
                     <rect
                        class="cls-4"
                        x="181.57"
                        y="447.99"
                        width="47.97"
                        height="121.73"
                     />
                     <rect
                        class="cls-8"
                        x="181.57"
                        y="151.49"
                        width="47.97"
                        height="33.37"
                     />
                     <rect
                        class="cls-8"
                        x="276.95"
                        y="229.85"
                        width="47.97"
                        height="151.11"
                     />
                     <rect
                        class="cls-9"
                        x="266.36"
                        y="218.92"
                        width="69.15"
                        height="173.59"
                     />
                     <rect
                        class="cls-9"
                        x="266.36"
                        y="436.75"
                        width="69.15"
                        height="144.37"
                     />
                     <rect class="cls-9" x="266.36" y="140.56" width="69.15" height="55" />
                     <rect
                        class="cls-4"
                        x="276.95"
                        y="447.99"
                        width="47.97"
                        height="121.73"
                     />
                     <rect
                        class="cls-8"
                        x="276.95"
                        y="151.49"
                        width="47.97"
                        height="33.37"
                     />
                     <polygon
                        class="cls-10"
                        points="220.82 424.45 213.43 424.45 230.03 403.43 237.42 403.43 220.82 424.45"
                     />
                     <polygon
                        class="cls-10"
                        points="225.13 424.45 222.5 424.45 239.09 403.43 241.72 403.43 225.13 424.45"
                     />
                     <polygon
                        class="cls-11"
                        points="181.57 255.54 207.28 229.84 222.5 229.84 181.57 270.76 181.57 255.54"
                     />
                     <polygon
                        class="cls-11"
                        points="181.57 276.79 229.02 229.34 229.02 232.67 181.57 280.13 181.57 276.79"
                     />
                     <rect
                        class="cls-9"
                        x="181.57"
                        y="229.85"
                        width="47.97"
                        height="151.11"
                     />
                     <polygon
                        class="cls-11"
                        points="276.95 255.54 302.66 229.84 317.88 229.84 276.95 270.76 276.95 255.54"
                     />
                     <polygon
                        class="cls-11"
                        points="276.95 276.79 324.41 229.34 324.41 232.67 276.95 280.13 276.95 276.79"
                     />
                     <polygon
                        class="cls-11"
                        points="276.95 177.69 302.66 151.99 317.88 151.99 285 184.86 276.95 184.86 276.95 177.69"
                     />
                     <polygon
                        class="cls-11"
                        points="291.03 184.86 324.41 151.49 324.41 154.83 294.37 184.86 291.03 184.86"
                     />
                     <rect
                        class="cls-9"
                        x="276.95"
                        y="229.85"
                        width="47.97"
                        height="151.11"
                     />
                     <rect
                        class="cls-9"
                        x="276.95"
                        y="151.49"
                        width="47.97"
                        height="33.37"
                     />
                     <polygon
                        class="cls-11"
                        points="181.57 177.69 207.28 151.99 222.5 151.99 189.62 184.86 181.57 184.86 181.57 177.69"
                     />
                     <polygon
                        class="cls-11"
                        points="195.65 184.86 229.02 151.49 229.02 154.83 198.99 184.86 195.65 184.86"
                     />
                     <rect
                        class="cls-9"
                        x="181.57"
                        y="151.49"
                        width="47.97"
                        height="33.37"
                     />
                     <rect
                        class="cls-7"
                        x="327.47"
                        y="381.04"
                        width="56.48"
                        height="9.65"
                        rx="4.83"
                        transform="translate(741.58 30.16) rotate(90)"
                     />
                     <rect
                        class="cls-7"
                        id="handle"
                        x="320.47"
                        y="369.32"
                        width="37.43"
                        height="7.02"
                        rx="3.51"
                     />
                     <circle class="cls-12" cx="355.71" cy="398.07" r="2.19" />
                     </g>

                  </g>
               </g>
               </svg>
            </div>
         <div id="housecontent">
            <img src="/ReactAssets/CustomerJourney/keypaths/desktop/Key.svg" alt="key" class="key"/>
            <h2>You've got the keys!</h2>
            <p>The wait is over. Your moving-in day has arrived. We know it’ll be an exciting (and busy) day. We’ll be there with you, and during your handover meeting we’ll have a final look around together and once the solicitors have given the thumbs up, we’ll hand you the keys. Happy new home!</p>
            <svg className="chevron" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
               <g id="Group_677" data-name="Group 677" transform="translate(-636 -8690)">
                  <path id="Path_542" data-name="Path 542" d="M6037.646,2182.378,6049,2193.89l10.963-11.511" transform="translate(-5389 6527)" fill="none" stroke="#a39161" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  <g id="Ellipse_562" data-name="Ellipse 562" transform="translate(636 8690)" fill="none" stroke="#a39161" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                     <circle cx="24" cy="24" r="24" stroke="none"/>
                     <circle cx="24" cy="24" r="23" fill="none"/>
                  </g>
               </g>
            </svg>
         </div>
      </div>
     </div>
     
    
  </>
   )
 }
 
 export default House;

